export class NumberUtils {
    static isValid(number: number): boolean {
        return number !== null && number !== undefined;
    }

    static isValidNumberString(text: string): boolean {
        return !isNaN(+text);
    }
}